import type { TourDefinition } from '../tours.types';


export const STEP1_CREATE_LOTE_TOUR: TourDefinition = {
  id: 'step1_create_lote_help',
  //route: '/firmas/firma',
  remember: true,
  steps: [
    {
      element: '[data-tour="firma-step1-root"]',
      popover: {
        title: 'Configuración del proceso de firma',
        description:
          'En este paso defines los parámetros con los que se realizará la firma de documentos. Estas opciones determinan cómo se notificará a los firmantes y si el proceso será individual, si quieres usar una plantilla o iniciar un proceso de firma grupal.',
        side: 'bottom',
        align: 'center',
      },
    },

    {
      element: '[data-tour="firma-titulo"]',
      popover: {
        title: 'Título del proceso',
        description:
          'Este título identifica el proceso de firma dentro del sistema. Utiliza un nombre descriptivo que te permita reconocer fácilmente este proceso más adelante.',
        side: 'bottom',
        align: 'start',
      },
    },

    {
      element: '[data-tour="firma-notificar"]',
      popover: {
        title: 'Notificaciones a firmantes',
        description:
          'Los firmantes recibirán notificaciones push en sus dispositivos y alertas dentro del sistema cuando se solicite su firma.',
        side: 'right',
        align: 'center',
      },
    },
    {
      element: '[data-tour="firma-es-grupo"]',
      popover: {
        title: 'Firma grupal',
        description:
          'Activa esta opción si el documento será firmado por un grupo de personas. En una firma grupal, todos los firmantes reciben el mismo documento y el proceso se gestiona de forma conjunta.',
        side: 'right',
        align: 'center',
      },
    },

    {
      element: '[data-tour="firma-por-plantilla"]',
      popover: {
        title: 'Firma por plantilla',
        description:
          'Esta opción permite utilizar una plantilla con posiciones de firma predefinidas. Solo está disponible para procesos de firma individual y se desactiva cuando la firma es grupal.',
        side: 'right',
        align: 'center',
      },
    },
    {
      element: '[data-tour="firma-next"]',
      popover: {
        title: 'Continuar',
        description:
          'Cuando hayas definido los parámetros del proceso de firma, continúa al siguiente paso para cargar los documentos y configurar los firmantes.',
        side: 'left',
        align: 'center',
      },
    },
  ],
};
